class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    this.kbFresh = false;
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    // Keter: se il carrello e' appena stato aggiornato (o lo sta per essere), non ricaricarlo una seconda volta
    if (this.kbFresh || this.classList.contains('kb-loading')) {
      document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      return;
    }

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        if (this.kbFresh) return;
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');

          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.kbFresh = true;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.classList.remove('kb-loading');
    clearTimeout(this.kbLoadingTimer);
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);

/* ---------------------------------------------------------------
   Keter: ritocchi ottobre 2026
   1) Carrello: si apre subito al tocco su "Aggiungi al carrello"
   2) Pop-up newsletter: dopo 30 secondi di visita, mai a chi ha usato il quiz
   3) WhatsApp a destra, nascosto quando il carrello e' aperto
   --------------------------------------------------------------- */
(function () {
  if (window.__kbTweaks) return;
  window.__kbTweaks = true;

  var POPUP_DELAY = 30000;
  var QUIZ_KEY = 'kb_quiz_touched';
  var START_KEY = 'kb_session_start';

  function store(type, key, value) {
    try {
      var s = window[type];
      if (value === undefined) return s.getItem(key);
      s.setItem(key, value);
    } catch (e) { return null; }
  }

  // Stili
  var css = ''
    + 'mini-cart.kb-loading::before{content:"";position:absolute;top:0;left:0;height:3px;width:40%;background:#1A5283;z-index:20;animation:kb-cart-bar 1s ease-in-out infinite}'
    + 'mini-cart.kb-loading>*{opacity:.45;transition:opacity .2s;pointer-events:none}'
    + '@keyframes kb-cart-bar{0%{transform:translateX(-100%)}100%{transform:translateX(260%)}}'
    + '#chat-bubble.whatsapp-widget{left:auto!important;right:14px!important;bottom:72px!important}'
    + '@media (max-width:749px){#chat-bubble.whatsapp-widget{right:10px!important;bottom:66px!important;transform:scale(.85);transform-origin:bottom right}}'
    + 'body.kb-drawer-open #chat-bubble{display:none!important}';
  var st = document.createElement('style');
  st.id = 'kb-tweaks';
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  // 1) Carrello che si apre subito
  document.addEventListener('submit', function (event) {
    var form = event.target;
    var pf = form && form.closest ? form.closest('product-form') : null;
    if (!pf) return;
    if (!window.shopSettings || !window.shopSettings.cartDrawer) return;
    if (document.body.classList.contains('template-cart')) return;
    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.getAttribute('aria-disabled') === 'true') return;
    var mc = document.querySelector('mini-cart');
    if (!mc || !mc.drawer) return;
    mc.classList.add('kb-loading');
    clearTimeout(mc.kbLoadingTimer);
    mc.kbLoadingTimer = setTimeout(function () { mc.classList.remove('kb-loading'); }, 8000);
    try { mc.open(); } catch (e) {}
  }, true);

  customElements.whenDefined('product-form').then(function () {
    var PF = customElements.get('product-form');
    if (!PF || !PF.prototype.handleErrorMessage || PF.prototype.__kbPatched) return;
    PF.prototype.__kbPatched = true;
    var original = PF.prototype.handleErrorMessage;
    PF.prototype.handleErrorMessage = function (message) {
      if (message) {
        var mc = document.querySelector('mini-cart');
        if (mc && mc.classList.contains('kb-loading')) {
          mc.classList.remove('kb-loading');
          var drawer = mc.drawer || document.querySelector('cart-drawer');
          try { drawer.closeMenuDrawer(new Event('click')); } catch (e) {
            var d = drawer && drawer.querySelector('details');
            if (d) d.removeAttribute('open');
          }
        }
      }
      return original.apply(this, arguments);
    };
  });

  // 2) Pop-up newsletter (Mailchimp) e 3) WhatsApp
  var start = parseInt(store('sessionStorage', START_KEY) || '0', 10);
  if (!start) { start = Date.now(); store('sessionStorage', START_KEY, String(start)); }
  var onQuizPage = /\/pages\/trova-la-tua-routine/.test(location.pathname);

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (t && t.closest && t.closest('[id*="keter_quiz"],[id*="keter-quiz"],[id*="cause_quiz"],[id*="cause-quiz"],[data-kb-quiz]')) {
      store('localStorage', QUIZ_KEY, '1');
    }
  }, true);

  function drawerOpen() {
    var d = document.querySelector('cart-drawer details');
    return !!(d && d.hasAttribute('open'));
  }

  function gate() {
    var open = drawerOpen();
    if (document.body) document.body.classList.toggle('kb-drawer-open', open);
    var hide = open || onQuizPage || store('localStorage', QUIZ_KEY) === '1' || (Date.now() - start) < POPUP_DELAY;
    var hosts = document.querySelectorAll('[id^="mcforms-"]');
    for (var i = 0; i < hosts.length; i++) {
      if (hide) hosts[i].style.setProperty('display', 'none', 'important');
      else hosts[i].style.removeProperty('display');
    }
  }
  gate();
  setInterval(gate, 400);
})();
